<template>
  <!-- <pre v-if="responseData"> testData={{ response }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/CCTV DI SELURUH MALAYSIA.png"
        alt="CCTV"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <!--
          <div class="input-item">
          <AppAutocomplete
          v-model="selectedYear"
          label="Bulan"
          :items="years"
          placeholder="Pilih Bulan"
          chips
          class="app-date-picker"
          />
          </div> 
        -->

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      
      <h2>Ringkasan Pemasangan CCTV di PBT Seluruh Malaysia</h2>
      <div class="cctv">
        <div class="cctv-container">
          <img
            src="@/assets/spah/box.png"
            alt="First Image"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>Jumlah CCTV</h3>
              <p class="number">
                {{ cctv.jumlah }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-wrapper">
      <h2>Taburan Pemasangan CCTV di PBT Seluruh Malaysia</h2>
      <div class="carousel-wrapper">
        <div class="carousel">
          <VSlickCarousel
            v-bind="settings"
            :key="carouselKey"
          >
            <div class="map-container">
              <div class="state-column left">
                <div
                  v-for="(cctvData, state) in leftStatesData"
                  :key="state"
                  class="state-box"
                  @click="openStatePopup(state)"
                >
                  <div class="state-content">
                    <h2>{{ state }}</h2>
                    <p>{{ cctvData }}</p>
                  </div>
                </div>
              </div>
  
              <div class="map-image-container">
                <img
                  src="@/assets/map/Map.png"
                  alt="Image 1"
                  class="carousel-image"
                >
              </div>

              <div class="state-column right">
                <div
                  v-for="(cctvData, state) in rightStatesData"
                  :key="state"
                  class="state-box"
                  @click="openStatePopup(state)"
                >
                  <div class="state-content">
                    <h2>{{ state }}</h2>
                    <p>{{ cctvData }}</p>
                  </div>
                </div>
              </div>
            </div>


            <div class="map-container">
              <div class="map-image-container">
                <img
                  src="@/assets/map/Map2.png"
                  alt="Image 1"
                  class="carousel-image"
                >
              </div>
              <div class="state-column right">
                <div
                  v-for="(cctvData, state) in sabahStatesData"
                  :key="state"
                  class="state-box"
                  @click="openStatePopup(state)"
                >
                  <div class="state-content">
                    <h2>{{ state }}</h2>
                    <p>{{ cctvData }}</p>
                  </div>
                </div>
              </div>
            </div>
          </VSlickCarousel>
        </div>
      </div>

      <div
        v-if="isPopupOpen"
        class="modal-overlay"
        @click.self="closePopup"
      >
        <div class="modal-content">
          <div class="flex justify-between text-black">
            <div style="font-weight: bold; font-size: 1.5em;">
              Data CCTV
            </div>
            <div style="font-weight: bold; font-size: 1.5em;">
              {{ selectedState }}
            </div>
          </div>

          <div class="table-wrapper">
            <table class="popup-table">
              <thead>
                <tr>
                  <td
                    rowspan="2"
                    class="bg-gray-600 text-white text-center p-5 border border-white"
                  >
                    PBT
                  </td>
                  <th
                    rowspan="2"
                    class="bg-gray-800 text-white text-center p-5 border border-white"
                  >
                    KPKT
                  </th>
                  <th
                    colspan="2"
                    scope="colgroup"
                    class="bg-yellow-600 text-white text-center p-5 border border-white"
                  >
                    Pemasangan oleh PBT
                  </th>
                  <th
                    colspan="2"
                    scope="colgroup"
                    class="bg-blue-600 text-white text-center p-5 border border-white"
                  >
                    Jenayah
                  </th>
                </tr>
                <tr>
                  <th
                    class="border p-5 text-black bg-yellow-100"
                    scope="col"
                  >
                    Lokasi Awam
                  </th>
                  <th
                    class="border p-5 text-black bg-yellow-100"
                    scope="col"
                  >
                    Bangunan
                  </th>
                  <th
                    class="border p-5 text-black bg-blue-100"
                    scope="col"
                  >
                    Lokasi Hotspot
                  </th>
                  <th
                    class="border p-5 text-black bg-blue-100"
                    scope="col"
                  >
                    Indeks
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="pbt in stateData[selectedState]"
                  :key="pbt.name"
                >
                  <td>{{ pbt.name || "Tiada Maklumat" }}</td>
                  <td>{{ pbt.kpkt || "Tiada Maklumat" }}</td>
                  <td>{{ pbt.pemasangan || "Tiada Maklumat" }}</td>
                  <td>{{ pbt.linkPDRM || "Tiada Maklumat" }}</td>
                  <td>{{ pbt.hotspot || "Tiada Maklumat" }}</td>
                  <td>{{ pbt.index || "Tiada Maklumat" }}</td>
                </tr>
              </tbody>
            </table>
          </div>


          <button @click="closePopup">
            Tutup
          </button>
        </div>
      </div>
    </div>

    <PrimaryModule />
    <KejuruteraanAwamMenu />
  </adminbackground>
</template>


<script setup>
import { useHttpService } from "@/httpService"
import { VSlickCarousel } from 'v-slick-carousel'
import 'v-slick-carousel/style.css'
import { onMounted, ref } from 'vue'

defineProps({
  stateName: {
    type: String,
    required: true,
  },
})

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion, calculatePercentage } = useHttpService()

const cctv = ref({
  jumlah: 0,
})

const responseData = ref(null)
const leftStatesData = ref({})
const rightStatesData = ref({})
const sabahStatesData = ref({})


const isPopupOpen = ref(false)
const selectedState = ref('')

const stateData = ref({})


function openStatePopup(state) {
  selectedState.value = state
  isPopupOpen.value = true
}


function closePopup() {
  isPopupOpen.value = false
}


const settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
}

const carouselKey = computed(() => {
  return `${selectedYear.value}-${JSON.stringify(leftStatesData.value)}-${JSON.stringify(rightStatesData.value)}-${JSON.stringify(sabahStatesData.value)}`
})


function getCctvdata(stateName) {

  if(responseData.value){
    const stateData = responseData.value.cctv_by_states.find(item => item.state == stateName)  
  
    return stateData ? stateData.jumlah : '0'
  }
  
  return 'no data'
}


async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}`

    if (!plainStates.includes("Semua Negeri")) {

      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    const url = `kejuruteraan-awam/cctv?${selectedYear.value}${queryParams}`

    const response = await httpGet(url)

    years.value = response.years
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })

    councils.value = response.councils
    responseData.value = response
    cctv.value = response.data.data

    cctv.value = {
      jumlah: cctv.value.jumlah,
    }

    leftStatesData.value = {
      PERLIS: getCctvdata('Perlis'),
      KEDAH: getCctvdata('Kedah'),
      "PULAU PINANG": getCctvdata('Pulau Pinang'),
      PERAK: getCctvdata('Perak'),
      SELANGOR: getCctvdata('Selangor'),
      "KUALA LUMPUR": getCctvdata('W.p Kuala Lumpur'),
      PUTRAJAYA: getCctvdata('W.p Putrajaya'),
    }

    rightStatesData.value = {
      "NEGERI SEMBILAN": getCctvdata('Negeri Sembilan'),
      MELAKA: getCctvdata('Melaka'),
      KELANTAN: getCctvdata('Kelantan'),
      TERENGGANU: getCctvdata('Terengganu'),
      PAHANG: getCctvdata('Pahang'),
      JOHOR: getCctvdata('Johor'),
    }

    sabahStatesData.value = {
      SABAH: getCctvdata('Wilayah Sabah'),
      SARAWAK: getCctvdata('Wilayah Sarawak'),
      LABUAN: getCctvdata('W.p Labuan'),
    }
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

async function loadDataFromApiMap(stateName) {
  try {
    let apiStateName = stateName 

    if (stateName === "PULAU PINANG") {
      apiStateName = "Pulau+Pinang"
    } else if (stateName === "KUALA LUMPUR") {
      apiStateName = "W.p+Kuala+Lumpur"
    } else if (stateName === "PUTRAJAYA") {
      apiStateName = "W.p+Putrajaya"
    } else if (stateName === "NEGERI SEMBILAN") {
      apiStateName = "Negeri+Sembilan"
    } else if (stateName === "SABAH") {
      apiStateName = "Wilayah+Sabah"
    } else if (stateName === "LABUAN") {
      apiStateName = "W.p+Labuan"
    } else if (stateName === "SARAWAK") {
      apiStateName = "Wilayah+Sarawak"
    }

    const response = await fetch(
      `https://jktgateway.kpkt.gov.my/api/kejuruteraan-awam/cctv-by-states?state=${apiStateName}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    if (response.ok) {
      const data = await response.json()

      if (data.data && Array.isArray(data.data)) {
        const formattedData = data.data.map(item => ({
          name: item.council || "Tiada Maklumat",
          kpkt: item.kpkt_link_pdrm || "Tiada Maklumat",
          pemasangan: item.pbt_link_pdrm || "Tiada Maklumat",
          linkPDRM: item.pbt_tidak_link_pdrm || "Tiada Maklumat",
        }))

     
        stateData.value = {
          ...stateData.value,
          [stateName]: formattedData,
        }
      } else {
        console.warn(`No valid data for state: ${stateName}`)
        stateData.value[stateName] = []
      }
    } else {
      console.error(`API Error: ${response.status}`)
    }
  } catch (err) {
    console.error("Failed to fetch data from API:", err)
  }
}




function handleStateChange() {
  pbt.value = []

  // Ensure selectedsState and selectedPbt are arrays
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }

  // Remove "Semua Negeri" if other states are selected
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }

  // Remove "Semua PBT" if other PBTs are selected
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }

  // If no states are selected, reset to "Semua Negeri"
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }

  // If no PBTs are selected, reset to "Semua PBT"
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }

  if (selectedsState.value.includes("Semua Negeri")) {
    // Add all councils from all states
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    // Only add councils for the selected states
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApiMap() 
})



watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })

watch(selectedState, newState => {
  if (newState) {
    loadDataFromApiMap(newState)
  }
})
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); 
  border-radius: 20px; 
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); 
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%;
  height: auto;
}

.line-under-image {
  width: 70%; 
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
  text-transform: uppercase;
}

.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}


.cctv {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.cctv-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  max-width: 500px;
  margin-right: 20px;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; 
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.carousel-wrapper {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 10px;
  inline-size: 100%;
  max-inline-size: 1200px;
}

.carousel {
  margin-block: 0;
  margin-inline: auto;
  max-inline-size: 95%; 
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.map-image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 70%;
  margin-block-start: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}

.carousel-image {
  block-size: auto;
  inline-size: 100%;
}

.map-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}


.state-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-block-start: 30px;
}

.state-column.left {
  align-items: flex-end;
  inset-inline-start: 0;
}

.state-column.right {
  align-items: flex-start;
  inset-inline-end: 0;
}


.map-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}


.state-box {
  padding: 15px;
  border-radius: 7px;
  background: linear-gradient(95.35deg, #2900cf);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 10%);
  color: white;
  min-inline-size: 180px; 
  text-align: center;
}


.state-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.5rem; 
}


.state-content h2 {
  flex-basis: 70%;
  margin: 0;
  color: white;
  font-size: 1rem;
  text-align: start; 
}


.state-content p {
  flex-basis: 30%;
  margin: 0;
  color: white;
  font-size: 1rem;
  text-align: end; 
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  font-family: Arial, sans-serif;
}


.popup-table td {
  padding: 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
  color: black;
}

.popup-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.popup-table tr:nth-child(odd) {
  background-color: #fcfcfc;
}

.popup-table tr:hover {
  background-color: #c8e6c9;
  cursor: pointer;
}

button {
  margin-top: 20px;
  padding: 10px 20px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

button:hover {
  background: #0056b3;
}


.modal-content {
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  text-align: center;
}

.modal-content h3 {
  margin-bottom: 20px;
  color: #4caf50;
  font-size: 18px;
}

.table-wrapper {
  max-height: 400px; 
  overflow-y: auto;

  border-radius: 5px;
}


@media (max-width: 768px) {
  h2 {
    font-size: 1.3rem;
  }

  .input-row {
    flex-direction: column;
    gap: 10px;
  }

  .state-content {
    font-size: 1.2rem;
  }

  .map-container {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 1.1rem;
  }

  .state-box {
    padding: 10px;
    min-width: 100%;
  }

  .state-content h2 {
    font-size: 1rem;
  }

  .state-content p {
    font-size: 0.9rem;
  }

  .carousel-wrapper {
    padding: 10px;
  }
}
</style>

